<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="textNavigationTaskDetails">
      <div class="pl-6 pr-6 pb-6">
        <div v-if="this.$siteTypeId() != 1">
          <div>
            <label>Task Classification</label>
            <v-select class="mb-3" ref="taskClassificationTypeDropdown" placeholder="Search / Select Task Classification"  :options="taskClassificationTypeList" v-model="taskClassificationTypeText"></v-select>
          </div>
        </div>
        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" class="w-full" v-model="formData.name"/>
        </div>

        <div class="pt-4 pb-2">
          <label>Title</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.title"/>
          <label>Description</label>
          <quill-editor v-model="formData.description" :options="editorOption" />
        </div>

        <div class="mt-2">
          <label>Scene</label>
          <vs-select placeholder="Search / Select Scene" class="w-full" vs-multiple autocomplete v-model="formData.sceneId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in scenes" />
          </vs-select>
        </div>

        <div class="mt-3" style="display: inline-grid;">
          <label>Task Number</label>
          <vs-input-number class="numberinput" onClick="this.select();" v-model="formData.number" min="0" />
        </div>
        <div v-if="this.$siteTypeId() != 1">
          <vs-divider>Outcomes</vs-divider>

            <div>
              <label>Assessment Criteria</label>
              <v-select class="mb-2" ref="assessmentCriteriaDropdown" placeholder="Search / Select Assessment Criteria"  :options="assessmentCriteriaList" v-model="assessmentCriteriaText"></v-select>
            </div>
            <div>
              <label>Essential Embedded Knowledge</label>
              <v-select class="mb-2" ref="eEKDropdown" placeholder="Search / Select EEK"  :options="eekList" v-model="essentialEmbeddedKnowledgeText"></v-select>
            </div>
            <div>
              <label>Unit Standard</label>
              <v-select class="mb-2" ref="unitStandardDropdown" placeholder="Search / Select Unit Standard"  :options="unitStandardList" v-model="unitStandardText"></v-select>
            </div>
              <div>
                <label>Spesific Outcome</label>
                <v-select class="mb-2" ref="spesificOutcomeDropdown" placeholder="Search / Select Spesific Outcome"  :options="spesificOutcomeList" v-model="spesificOutcomeText"></v-select>
              </div>
          </div>
        <vs-divider>Go To</vs-divider>

        <!-- <div class="pt-1">
          <vs-radio v-model="gotoRadio" vs-value="existingTask">Existing Task</vs-radio>
        </div>
        <div class="pt-2">
          <vs-radio v-model="gotoRadio" vs-value="newTask">Create New Task</vs-radio>
        </div> -->
        <div class="pt-2">
          <vs-radio v-model="gotoRadio" vs-value="multipleTasks">Multiple Tasks</vs-radio>
        </div>
        <div class="pt-2">
          <vs-radio v-model="gotoRadio" vs-value="none">None</vs-radio>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'existingTask'">
          <label>Go To</label>
          <vs-select placeholder="Search / Select Go To task" class="w-full pb-3" vs-multiple autocomplete v-model="formData.goTo">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'existingTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'newTask'">
          <label>Task Type</label>
          <vs-select placeholder="Search / Select a Task Type" class="w-full pb-3" vs-multiple autocomplete v-model="formData.taskTypeId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in taskTypeList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'newTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'multipleTasks'">
          <vs-divider>Options</vs-divider>
          <div class="pt-2 pb-4">
            <ul>
              <li v-for="(option, index) in formData.options" :key="index">
                <vx-card style="margin-bottom: 15px;">
                  <div>
                    <label class="pt-2 float-left">Go To</label>
                    <vs-button id="remove-option-button" radius size="small" type="border" color="danger" icon-pack="feather" icon="icon-x" @click="deleteRow(index)"></vs-button>
                  </div>
                  <vs-select class="w-full pb-4" vs-multiple autocomplete v-model="option.nextTaskId">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
                  </vs-select>
                  <div>
                    <div style="margin-bottom: 8px; margin-top: 2px;">
                      <vs-checkbox color="success" v-model="option.useCoins">Coins</vs-checkbox>
                    </div>
                    <div v-if="option.useCoins && gotoRadio == 'multipleTasks'">
                      <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                        <vs-switch color="success" v-model="option.isCoinsRecurring">
                          <span slot="on">Recurring</span>
                          <span slot="off">Once Only</span>
                        </vs-switch>
                        <vs-switch style="margin-left: 10px;" color="success" v-model="option.addCoins">
                          <span slot="on">Add</span>
                          <span slot="off">Deduct</span>
                        </vs-switch>
                      </div>
                      <label style="margin-left: 5px;">Coin Value</label>
                      <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="option.coinValue" />
                      <span class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
                    </div>
                  </div>
                  <div class="mt-4">
                    <label>Text</label>
                    <vs-textarea name="Text" class="w-full" v-model="option.text" />
                  </div>
                </vx-card>
              </li>
            </ul>
          </div>
          <div>
            <vs-button ref="optionsAdd" class="w-full cursor-pointer" type="border" color="success" icon-pack="feather" icon="icon-plus" @click="addOptions"></vs-button><!-- v-scroll-to="'#charlook'" -->
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditTextNavigation" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" @click="deleteApproach" v-show="formData.id" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    courseId: {
      type: String,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    nodeSelected: {
      type: Object,
      required: false
    },
     taskClassificationTypes: {
      type: Array,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
    gotoList: {
      type: Array,
      required: false
    },
    sourceTaskId: {
      type: Number,
      required: false
    },
    taskTypeList: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
        },
      },
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        name: "",
        sceneId: 0,
        title: "",
        description: "",
        goTo: 0,
        options: [],
        moduleId: "",
        sourceTaskId: 0,
        taskTypeId: 0,
        hasLogs: false,
        useCoins: false,
        isCoinsRecurring: false,
        addCoins: true,
        coinValue: "",
        number: 0,
        spesificOutcomeId: null,
        unitStandardId: null,
        assessmentCriteriaId: null,
        essentialEmbeddedKnowledgeId: null,
        taskClassificationTypeId: null,
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      characters: [],
      scenes: [],
      gotoRadio: "none",
      counterDanger: false,
      spesificOutcomeDropdown: null,
      unitStandardDropdown: null,
      assessmentCriteriaDropdown: null,
      eEKDropdown: null,
      taskClassificationTypeDropdown: null,
      spesificOutcomeList: [],
      unitStandardList: [],
      assessmentCriteriaList: [],
      eekList: [],
      taskClassificationTypeList: [],
      spesificOutcomeText: null,
      unitStandardText: null,
      assessmentCriteriaText: null,
      essentialEmbeddedKnowledgeText: null,
      taskClassificationTypeText: null,
    };
  },
  components: {
    quillEditor,
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  computed: {
    isDisabled: function() {
      return !(this.formData.sceneId);
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        this.gotoRadio = "none";
        var self = this;

        var goToDisplayValue = 0;
        if(self.nodeSelected.textNavigationTask)
          goToDisplayValue = self.nodeSelected.textNavigationTask.goTo;
        else
          goToDisplayValue = 0;

        var onSuccess = response => { self.scenes = response.data; };
        self.$ajaxGet(self, "scene/GetSelectList", onSuccess);

        self.formData.moduleId = self.moduleId;
        self.taskClassificationTypeList = self.taskClassificationTypes;

        self.getEEK();
        self.getUnitStandard();
        self.getSpesificOutcome();
        self.GetAssessmentCriteria();
        
        if(self.nodeSelected.id){
          self.formData.id = self.nodeSelected.id;
          self.formData.name = self.nodeSelected.name;
          self.formData.sourceTaskId = self.sourceTaskId;
          self.formData.title = self.nodeSelected.textNavigationTask.title;
          self.formData.description = self.nodeSelected.textNavigationTask.description;
          self.formData.sceneId = self.zeroIfEmpty(self.nodeSelected.textNavigationTask.sceneId);
          self.formData.hasLogs = self.nodeSelected.textNavigationTask.hasLogs;
          self.formData.useCoins = self.nodeSelected.textNavigationTask.coinValue ? true : false;
          self.formData.addCoins = self.nodeSelected.textNavigationTask.coinValue > 0 ? true : false;
          self.formData.isCoinsRecurring = self.nodeSelected.textNavigationTask.isCoinsRecurring;
          self.formData.coinValue = self.nodeSelected.textNavigationTask.coinValue > 0 ? self.nodeSelected.textNavigationTask.coinValue : (self.nodeSelected.textNavigationTask.coinValue * -1);

          self.taskClassificationTypeText = self.taskClassificationTypeList.filter(function(item){ return item.value == self.nodeSelected.taskClassificationTypeId})[0];

          if (self.nodeSelected.number)
            self.formData.number = self.nodeSelected.number;
          else
            self.formData.number = 0;
          
          if(goToDisplayValue != 0)
            self.formData.goTo = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == goToDisplayValue; })[0].value;

          if(self.formData.goTo){
            self.gotoRadio = "existingTask";
          } else if (self.nodeSelected.textNavigationTask.options && self.nodeSelected.textNavigationTask.options.length > 0){
            self.gotoRadio = "multipleTasks";
            self.formData.options = self.nodeSelected.textNavigationTask.options;
          } else {
            self.gotoRadio = "none";
          }

        }else{
          this.initValues(self.sourceTaskId || 0);
        }
      }else {
        var scrollOptions = {
          container: '#textNavigationTaskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 0, scrollOptions);
      }
    },
  },
  methods: {
    getEEK(){
      var self =this;

      var onSuccess = function (response) {
        self.eekList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.essentialEmbeddedKnowledgeText = self.eekList.filter(function(item){return item.value == self.nodeSelected.essentialEmbeddedKnowledgeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/EEK?courseId=" + self.courseId, onSuccess);
    },
    getUnitStandard(){
      var self =this;

      var onSuccess = function (response) {
        self.unitStandardList = response.data.map(function(item) {return {value: item.value,label: item.text}});
         if(self.nodeSelected.id){
          self.unitStandardText = self.unitStandardList.filter(function(item){return item.value == self.nodeSelected.unitStandardId})[0];
        }
      }

      self.$ajaxGet(self, "Course/UnitStandard?courseId=" + self.courseId, onSuccess);
    },
    getSpesificOutcome(){
      var self =this;

      var onSuccess = function (response) {
        self.spesificOutcomeList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.spesificOutcomeText = self.spesificOutcomeList.filter(function(item){return item.value == self.nodeSelected.spesificOutcomeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/SpecificOutcome?courseId=" + self.courseId, onSuccess);
    },
    GetAssessmentCriteria(){
      var self =this;

      var onSuccess = function (response) {
        self.assessmentCriteriaList = response.data.map(function(item) {return {value: item.value,label: item.text}});
         if(self.nodeSelected.id){
          self.assessmentCriteriaText = self.assessmentCriteriaList.filter(function(item){return item.value == self.nodeSelected.assessmentCriteriaId})[0];
        }
      }

      self.$ajaxGet(self, "Course/AssesmentCriteria?courseId=" + self.courseId, onSuccess);
    },
    addOptions() {
      this.formData.options.push({
        id: 0,
        taskId: this.formData.id,
        goTo: '',
        text: ''
      });
      var scrollOptions = {
        container: '#textNavigationTaskDetails',
        easing: 'ease-in',
        offset: 1000000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["optionsAdd"], 500, scrollOptions);
    },
    deleteRow(index) {
      this.formData.options.splice(index,1)
    },
    initValues(val) {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.sourceTaskId = 0;
      if(val){
        this.formData.sourceTaskId = val;
      }
      
      this.formData.title = "";
      this.formData.description = "";
      this.formData.sceneId = "";
      this.formData.goTo = "";
      this.gotoRadio = "none";
      this.formData.options = [];
      this.formData.taskTypeId = "";
      this.formData.useCoins = false;
      this.formData.addCoins = true;
      this.formData.isCoinsRecurring = false;
      this.formData.coinValue = "";
      this.formData.number = 0;
      this.errors.clear();
      this.spesificOutcomeText= null;
      this.unitStandardText = null;
      this.assessmentCriteriaText = null;
      this.essentialEmbeddedKnowledgeText = null;
      this.taskClassificationTypeText = null;
    },
    saveData(val,taskTypeId){
      this.$emit('saveData',val,taskTypeId);
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
      this.initValues(val);
    },
    addEditTextNavigation() {
      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();

          var onSuccess = response => {
            if(self.gotoRadio == "newTask"){
              self.saveData( response.data, self.formData.taskTypeId );
            }
            else {
              self.saveData(0, self.formData.taskTypeId);
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Task Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            }
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
          };

          if(self.gotoRadio == "none" || self.gotoRadio == "newTask"){
            self.formData.options = [];
            self.formData.goTo = "0";
          } else if (self.gotoRadio == "multipleTasks"){
            self.formData.goTo = "0";
          } else if (self.gotoRadio == "existingTask"){
            self.formData.options = [];
          }

          self.formData.taskClassificationTypeId = self.taskClassificationTypeText ? self.taskClassificationTypeText.value: null;

          self.formData.unitStandardId = self.unitStandardText ? self.unitStandardText.value: null

          self.formData.essentialEmbeddedKnowledgeId = self.essentialEmbeddedKnowledgeText ? self.essentialEmbeddedKnowledgeText.value: null;

          self.formData.assessmentCriteriaId = self.assessmentCriteriaText ?  self.assessmentCriteriaText.value: null;

          self.formData.spesificOutcomeId = self.spesificOutcomeText ?  self.spesificOutcomeText.value: null;
          

          self.$ajaxPost(self, "TextNavigationTask/AddEditTextNavigationTask", self.formData, onSuccess, onFinally);
        }
      });
      var scrollOptions = {
        container: '#textNavigationTaskDetails',
        easing: 'ease-in',
        offset: -1000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 500, scrollOptions);
    },
    deleteTask() {
      var self = this;
      self.showLoadingOnDeleteButton();
      if(self.formData.hasLogs)
        self.showLoadingOnCytoscape();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Task Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
        self.$vs.loading.close(self.$parent.$el);
      };

      self.$ajaxDelete(self, "TextNavigationTask/DeleteTextNavigationTask/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnCytoscape(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    deleteApproach() {
      if(this.formData.hasLogs)
        this.openConfirm();
      else
        this.deleteTask();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected text navigation task?',
        accept: this.deleteTask,
        acceptText: "Yes, delete",
        cancelText: "No, cancel"
      })
    },
  },
};
</script>




<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  #remove-option-button {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
